import { render } from "./time-payment.view.vue?vue&type=template&id=0e31e60e&ts=true"
import script from "./time-payment.view.vue?vue&type=script&lang=ts"
export * from "./time-payment.view.vue?vue&type=script&lang=ts"

import "./time-payment.view.vue?vue&type=style&index=0&id=0e31e60e&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__